import {
    GET_CUSTOMER_INVOICES_SUCCESS,
    GET_CUSTOMER_INVOICES_FAIL,
    GET_CUSTOMER_INVOICE_DETAIL_SUCCESS,
    GET_CUSTOMER_INVOICE_DETAIL_FAIL,
    ADD_NEW_CUSTOMER_INVOICE_SUCCESS,
    ADD_NEW_CUSTOMER_INVOICE_FAIL,
    UPDATE_CUSTOMER_INVOICE_SUCCESS,
    UPDATE_CUSTOMER_INVOICE_FAIL,
    DELETE_CUSTOMER_INVOICE_SUCCESS,
    DELETE_CUSTOMER_INVOICE_FAIL,
    ADD_NEW_PAYMENT_SUCCESS,
    ADD_NEW_PAYMENT_FAIL,
} from "./actionTypes"

const INIT_STATE = {
    invoices: { data: [], current_page: 1, total: 0 },
    invoice: null,
    error: {},
}

const Invoices = (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_CUSTOMER_INVOICES_SUCCESS:
            return {
                ...state,
                invoices: action.payload,
            }

        case GET_CUSTOMER_INVOICES_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case GET_CUSTOMER_INVOICE_DETAIL_SUCCESS:
            return {
                ...state,
                invoice: action.payload,
            }

        case GET_CUSTOMER_INVOICE_DETAIL_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case ADD_NEW_CUSTOMER_INVOICE_SUCCESS:
            return {
                ...state,
                invoices: {
                    ...state.invoices,
                    data: [action.payload, ...state.invoices.data],
                },
            }

        case ADD_NEW_CUSTOMER_INVOICE_FAIL:
        case UPDATE_CUSTOMER_INVOICE_FAIL:
        case DELETE_CUSTOMER_INVOICE_FAIL:
        case ADD_NEW_PAYMENT_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case UPDATE_CUSTOMER_INVOICE_SUCCESS:
            return {
                ...state,
                invoices: {
                    ...state.invoices,
                    data: state.invoices.data.map(inv =>
                        inv.id.toString() === action.payload.id.toString()
                            ? { ...inv, ...action.payload }
                            : inv
                    ),
                },
            }

        case DELETE_CUSTOMER_INVOICE_SUCCESS:
            return {
                ...state,
                invoices: {
                    ...state.invoices,
                    data: state.invoices.data.filter(
                        inv => inv.id.toString() !== action.payload.toString()
                    ),
                },
            }

        case ADD_NEW_PAYMENT_SUCCESS:
            // Refresh invoice detail if showing
            if (state.invoice && state.invoice.id === action.payload.invoice_id) {
                return {
                    ...state,
                    invoice: {
                        ...state.invoice,
                        payments: [...(state.invoice.payments || []), action.payload],
                        paid_amount: state.invoice.paid_amount + action.payload.amount,
                        balance: state.invoice.balance - action.payload.amount,
                    },
                }
            }
            return state

        default:
            return state
    }
}

export default Invoices
